import { handleActions } from 'redux-actions';

import { resourceStoreTypes, resourceUpserters } from '../core';

import * as entitlementsActions from './entitlementsActions';
import * as entitlementsTypes from './entitlementsTypes';

const entitlementsReducer = handleActions(
  {
    [entitlementsActions.getEntitlements]: (state) => state.merge({ isLoading: true }),
    [entitlementsActions.getEntitlementsSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload),
    [entitlementsActions.getEntitlementsFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),

    [entitlementsActions.createEntitlement]: (state) => state.merge({ isLoading: true }),
    [entitlementsActions.createEntitlementSuccess]: (state, { payload }) =>
      resourceUpserters.upsertResources(state, payload),
    [entitlementsActions.createEntitlementFailure]: (state, { payload: error }) =>
      resourceUpserters.completeWithError(state, error),
  },
  resourceStoreTypes.mkQcsSyncResourceStore(),
);

export const { ENTITLEMENTS_REDUCER_KEY } = entitlementsTypes;
export default entitlementsReducer;
